module.exports = __webpack_public_path__ + "static/img/Bachelor_010531.80af8b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010531.jpg
// module id = 182
// module chunks = 0